let connect = require("react-redux").connect;
import React from "react";

let actions = require("../actions/actions");
let Loading = require("./loading");
let UploadSearch = require("./moderation-uploads-search");
let UploadSlats = require("./moderation-uploads-slats");

class ModerationUploads extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.fetchNewUploads("");
    }

    loadMoreUploads() {
        if (
            this.props.batch.result !== "SEARCH_UPLOADS_SUCCESS" &&
            this.props.batch.pagination
        ) {
            this.props.fetchNewUploads(
                "",
                this.props.batch.pagination.pageCount + 1
            );
        }
    }

    render() {
        if (this.props.batch.uploads) {
            let button = this.renderButton();

            return (
                <div>
                    <UploadSearch
                        uploads={this.props.batch.uploads}
                        hasActiveUpload={this.props.hasActiveUpload}
                    />
                    <UploadSlats batch={this.props.batch} />
                    {button}
                </div>
            );
        } else {
            return <Loading />;
        }
    }

    renderButton() {
        let button = null;

        if (this.props.batch.uploads.length !== this.props.batch.totalUploads) {
            button = (
                <div>
                    <button
                        className="load-more btn btn-default black"
                        onClick={this.loadMoreUploads.bind(this)}
                    >
                        Load More
                    </button>
                </div>
            );
        }

        return button;
    }
}

function mapStateToProps(state, ownProps) {
    let batch = { uploads: null }, hasActiveUpload = null, keys;

    if (state.uploads.result) {
        batch.result = state.uploads.result;
    }

    if (state.uploads.result) {
        hasActiveUpload = state.uploads.has_active;

        if (state.uploads.keys) {
            batch.pagination = state.pagination.newUploads[""];

            if (state.uploadsNewSearchKeys.length > 0) {
                batch.uploads = [];
                keys = state.uploadsNewSearchKeys;
            } else if (state.uploadsNewKeys.length > 0) {
                batch.uploads = [];
                keys = state.uploadsNewKeys;
            }

            if (keys) {
                keys.forEach(uploadId => {
                    let upload = state.uploads[uploadId];
                    batch.uploads.push(upload);
                    if (state.uploadsNewSearchKeys.length === 0) {
                        batch.totalUploads = state.uploads.counts.new_batches;
                    } else {
                        batch.totalUploads = state.uploadsNewSearchKeys.length;
                    }
                });
            }
        }
    }

    return { batch, hasActiveUpload };
}

module.exports = connect(mapStateToProps, {
    fetchNewUploads: actions.fetchNewUploads
})(ModerationUploads);
